import React, { Component } from "react";
import SideBarLogo from "../../../../../../assets/SideBarLogo.jpg";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CategoryIcon from "@mui/icons-material/Category";
import ContactsIcon from "@mui/icons-material/Contacts";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import styles from "../../../../styles";

const {
  SideBarMainContainer,
  SideBarSubContaienr,
  SideBarListedItems,
  SideBarActiveListedItems,
} = styles;

class SideBar extends Component {
  state = {
    activeItemInNavMainOption: this.props.navPosition,
    navMainOptions: [
      {
        id: "numbers",
        icon: ContactPhoneIcon,
        color: "#ff0000",
        name: "Numbers",
      },
      {
        id: "orders",
        icon: MonetizationOnIcon,
        color: "#ff0000",
        name: "Orders",
      },
      {
        id: "category",
        icon: CategoryIcon,
        color: "#ff0000",
        name: "Category",
      },
      { id: "users", icon: ContactsIcon, color: "#ff0000", name: "Users" },
      {
        id: "homeConfig",
        icon: RoomPreferencesIcon,
        color: "#ff0000",
        name: "Home Configuration",
      },
      { id: "badge", icon: LoyaltyIcon, color: "#ff0000", name: "Badge" },
      {id: "blogs", icon: NoteAddIcon, color: "#ff0000", name: "Blogs"}
    ],
    navSubOptions: [],
  };

  handleSideBarItemClick = (activeItem) => {
    this.setState({ activeItemInNavMainOption: activeItem });
  };

  toggleSidebar = () => {
    const newExpandedState = !this.props.isExpanded;
    if (this.props.onToggle) {
      this.props.onToggle(newExpandedState);
    }
  };

  render() {
    return (
      <SideBarMainContainer isExpanded={this.props.isExpanded}>
        <SideBarSubContaienr>
          <SideBarListedItems
            style={{
              marginBottom: "50px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={this.toggleSidebar}
          >
            <img
              src={SideBarLogo}
              style={{
                width: "38px",
                backgroundColor: "white",
                borderRadius: "19px",
              }}
              alt="logo"
            />
            {this.props.isExpanded && (
              <span
                style={{
                  marginLeft: "10px",
                  color: "white",
                  fontSize: "20px",
                  fontWeight: "bold",
                  opacity: this.props.isExpanded ? 1 : 0,
                  transition: "opacity 0.3s ease-in-out",
                  whiteSpace: "nowrap",
                  overflow: "hidden"
                }}
              >
                VIP Studio
              </span>
            )}
          </SideBarListedItems>
          {this.state.navMainOptions.map((item, index) => {
            const IconComponent = item.icon;
            const isActive = index + 1 === this.state.activeItemInNavMainOption;

            return (
              <Tooltip
                key={index}
                title={this.props.isExpanded ? "" : item.name}
                placement="right"
                arrow
              >
                <Link
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                  to={`/admin/${item.id}`}
                >
                  <SideBarListedItems
                    style={
                      isActive
                        ? {
                            cursor: "pointer",
                            color: "white",
                          }
                        : {}
                    }
                    onClick={() => this.handleSideBarItemClick(index + 1)}
                  >
                    <SideBarActiveListedItems
                      style={
                        isActive
                          ? {
                              backgroundColor: "white",
                            }
                          : {}
                      }
                      id="active"
                    />
                    <IconComponent
                      style={{
                        width: "38px",
                        color: isActive ? "white" : item.color,
                      }}
                    />
                    {this.props.isExpanded && (
                      <span 
                        style={{ 
                          marginLeft: "10px", 
                          color: "white",
                          opacity: this.props.isExpanded ? 1 : 0,
                          transition: "opacity 0.3s ease-in-out",
                          whiteSpace: "nowrap",
                          overflow: "hidden"
                        }}
                      >
                        {item.name}
                      </span>
                    )}
                  </SideBarListedItems>
                </Link>
              </Tooltip>
            );
          })}
        </SideBarSubContaienr>
      </SideBarMainContainer>
    );
  }
}

export default SideBar;
